import React, { useRef } from 'react';
import { View } from 'react-native';
import { useNavigation } from '@react-navigation/native';

import Button from '../../Components/Button';
import EmptyData from '../../Components/EmptyData';
import List from '../../Components/List';
import ScaleButtonAnimation from '../../Components/Web/Intereaction/ScaleButtonAnimation';
import constants from '../../Config/constants';
import routeList from '../../Routes/list';
import ThemeStyle from '../../Theme/styles';

import Header from './Header';
import ItemOnGoing from './ItemOnGoing';
import ItemOnGoingLoader from './ItemOnGoingLoader';
import useOrderController from './index.controller';

const ClickableComponent = constants.isWeb ? ScaleButtonAnimation : Button;
const clickableProps = constants.isWeb
  ? {
      buttonStyle: ThemeStyle.webPageWrapper,
      contentStyle: ThemeStyle.webPageContainer,
    }
  : { plain: true };

const Orders = () => {
  const listRef = useRef();
  const navigation = useNavigation();
  const {
    arrivedRef,
    data,
    highlightedOrderId,
    isArriving,
    isRefreshing,
    showDetailsOrderId,
    onRefresh,
    onShare,
    onIhaveArrivedPress,
    onStoreNamePressed,
    onViewOrderPressed,
    toggleShowDetails,
  } = useOrderController();

  const _onHistoryPress = () => {
    navigation.navigate(routeList.ORDER_HISTORY);
  };

  const _renderHeader = () => <Header onHistoryPress={_onHistoryPress} />;

  const _renderEmpty = () => (
    <View
      style={[
        ThemeStyle.flex1,
        ThemeStyle.pageVerticalSpacing,
        ThemeStyle.pageHorizontalSpacing,
        ThemeStyle.alignItemsCenter,
      ]}
    >
      <EmptyData title={'No orders found'} type={'cart'} />
    </View>
  );

  const _renderItem = ({ item, index }) => {
    if (item.loading) {
      return <ItemOnGoingLoader />;
    }
    const isFirstHighlight = index === 0 && highlightedOrderId === 'first';
    return (
      <ClickableComponent
        onPress={toggleShowDetails(item)}
        href={constants.isWeb && `/store?id=${item?.store_details?.id}`}
        {...clickableProps}
      >
        <ItemOnGoing
          // add FE ref value for item.curbside_pickup_details.has_arrived
          // to immediately disable the i have arrived button and not wait for the next poll for the updated api data
          {...(item.order_type === 'curbside_pickup'
            ? {
                ...item,
                curbside_pickup_details: {
                  ...item.curbside_pickup_details,
                  has_arrived:
                    item.curbside_pickup_details.has_arrived ||
                    arrivedRef.current[item.id],
                },
              }
            : item)}
          isActive={isFirstHighlight || highlightedOrderId === item.id}
          isArriving={isArriving}
          showDetails={showDetailsOrderId === item.id}
          onShare={onShare(item.tracking_page)}
          onIhaveArrivedPress={onIhaveArrivedPress(item)}
          onStoreNamePress={onStoreNamePressed(item)}
          onViewOrderPress={onViewOrderPressed(item)}
        />
      </ClickableComponent>
    );
  };

  return (
    <List
      ref={listRef}
      data={data}
      listKey="order-history"
      ListEmptyComponent={_renderEmpty}
      ListHeaderComponent={!constants.isWeb && _renderHeader}
      renderItem={_renderItem}
      pullToRefreshProps={{ onRefresh, refreshing: isRefreshing }}
      contentContainerStyle={ThemeStyle.scrollContainer}
      keyExtractor={(item) => item.id}
      style={
        data.length === 0
          ? [ThemeStyle.flex1, ThemeStyle.pageBackground]
          : ThemeStyle.pageBackground
      }
      withSeparator
    />
  );
};

export default Orders;
